export default {"src":"/_next/static/media/support.fee84aa5.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};